export default "__VITE_ASSET__fMGA6TlX__"